import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href", "title"]
const _hoisted_2 = ["src", "alt"]

export function render(_ctx, _cache) {
  const _component_Carousel = _resolveComponent("Carousel")

  return (_openBlock(), _createBlock(_component_Carousel, {
    value: _ctx.products,
    numVisible: 3,
    numScroll: 1,
    responsiveOptions: _ctx.responsiveOptions,
    circular: "",
    autoplayInterval: 6000
  }, {
    item: _withCtx((slotProps) => [
      _createElementVNode("a", {
        href: slotProps.data.href,
        target: "_blank",
        title: slotProps.data.name,
        class: "block md:p-2.5 cursor-pointer"
      }, [
        _createElementVNode("img", {
          src: slotProps.data.image,
          alt: slotProps.data.name,
          class: "w-full"
        }, null, 8 /* PROPS */, _hoisted_2)
      ], 8 /* PROPS */, _hoisted_1)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["value", "responsiveOptions"]))
}